'use strict';
define([
    'angular',
    'modules/settings/update/update.controller'
],function(angular,UpdateController){
    var app=angular.module('settings.update', []);
    app.controller('UpdateController',UpdateController);
    return app;
});